import { useEffect, useState } from "react";
import { getCurrentUser, onAuthChange, signOut } from "@/lib/auth";
import { useCartLineCount } from "@/lib/cart/store";

type AuthUser = { id: string; email?: string | null } | null;

export function useAuth() {
  const [user, setUser] = useState<AuthUser>(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let mounted = true;
    getCurrentUser().then((u) => {
      if (!mounted) return;
      setUser(u ? { id: u.id, email: u.email } : null);
      setReady(true);
    });
    const unsub = onAuthChange(async (signedIn) => {
      if (!signedIn) {
        setUser(null);
        return;
      }
      const u = await getCurrentUser();
      if (mounted) setUser(u ? { id: u.id, email: u.email } : null);
    });
    return () => {
      mounted = false;
      unsub();
    };
  }, []);

  return {
    user,
    isAuthenticated: !!user,
    ready,
    signOut,
  };
}

// Placeholder until Cart module lands. Header reads via this hook so the
// Cart module can swap the implementation without touching the header.
export function useCartCount(): number {
  return useCartLineCount();
}
